export default __webpack_public_path__ + "static/4FXUBRANIA_DO_ODDANIA-b43b42ec28a92c028124089628f1d695.png";